import { render, staticRenderFns } from "./ServicesTypeForm.vue?vue&type=template&id=c50c5854&scoped=true&"
import script from "./ServicesTypeForm.vue?vue&type=script&lang=js&"
export * from "./ServicesTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c50c5854",
  null
  
)

export default component.exports